import "./universe.scss";
import coloredLogo from "../../assets/images/Logo Colored.svg";

import orbit1 from "../../assets/images/universe-imgs/dbeaver.png";
import orbit2 from "../../assets/images/universe-imgs/java.png";
import orbit3 from "../../assets/images/universe-imgs/laravel.png";
import orbit4 from "../../assets/images/universe-imgs/csharp.png";
import orbit5 from "../../assets/images/universe-imgs/c++.svg";
import orbit6 from "../../assets/images/universe-imgs/postgres.png";
import orbit7 from "../../assets/images/universe-imgs/python.png";
import orbit8 from "../../assets/images/universe-imgs/react.png";

// Inner stage is 640x640 (center at 320). Each tech shares the exact radius of its path.
// Orbital periods follow Kepler's 3rd law (simplified circular): T ∝ r^1.5
const STAGE_SIZE = 640;
const STAGE_CENTER = STAGE_SIZE / 2;
const BASE_RADIUS = 135;
const BASE_PERIOD = 48; // seconds for the innermost orbit

const keplerPeriod = (radius) =>
  Math.round(BASE_PERIOD * Math.pow(radius / BASE_RADIUS, 1.5));

// ~30px steps so 34px icons do not collide when orbits align
const orbits = [
  { img: orbit2, radius: 135, startAngle: 20, spin: 8 },
  { img: orbit3, radius: 165, startAngle: 200, spin: 10 },
  { img: orbit5, radius: 195, startAngle: 110, spin: 9 },
  { img: orbit7, radius: 225, startAngle: 290, spin: 7 },
  { img: orbit1, radius: 255, startAngle: 160, spin: 11 },
  { img: orbit6, radius: 280, startAngle: 40, spin: 8 },
  { img: orbit8, radius: 300, startAngle: 240, spin: 9 },
  { img: orbit4, radius: 318, startAngle: 330, spin: 10 },
].map((orbit) => ({
  ...orbit,
  duration: keplerPeriod(orbit.radius),
}));

const Universe = () => (
  <div className="universe-container" aria-hidden="true">
    <div className="universe-inner">
      <div className="center-image">
        <img src={coloredLogo} alt="" />
      </div>

      {orbits.map((orbit, idx) => (
        <div
          className="orbit-path"
          key={`path-${idx}`}
          style={{
            width: `${orbit.radius * 2}px`,
            height: `${orbit.radius * 2}px`,
            marginLeft: `${STAGE_CENTER - orbit.radius}px`,
            marginTop: `${STAGE_CENTER - orbit.radius}px`,
          }}
        />
      ))}

      {orbits.map((orbit, idx) => (
        <div className="orbit" key={`orbit-${idx}`}>
          <div
            className="orbit-spinner"
            style={{
              animation: `orbit-spin ${orbit.duration}s linear infinite`,
            }}
          >
            <div
              className="orbit-arm"
              style={{
                width: `${orbit.radius}px`,
                transform: `rotate(${orbit.startAngle}deg)`,
              }}
            >
              <span className="orbit-icon">
                <img
                  src={orbit.img}
                  alt=""
                  style={{
                    animation: `orbit-self-spin ${orbit.spin}s linear infinite`,
                  }}
                />
              </span>
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default Universe;
